import axios from 'axios'
import Cookie from 'js-cookie'
import store from '@/state/store'
import Swal from 'sweetalert2';

let user = { token: Cookie.get('_easyindustria_token') };
const API = `${process.env.VUE_APP_BASEURI}/api`;
store.dispatch('notification/clear', { root: true });

const http = axios.create({
  baseURL: API,
  headers: {
    Authorization: 'Bearer ' + `${user.token}`,
    ContentType: 'application/json',
    Accept: 'application/json'
  }
});

http.interceptors.request.use(
  function (config) {
    const token = Cookie.get('_easyindustria_token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    try {
      const raw = localStorage.getItem('currentEmpresa');
      if (raw && raw !== 'null') {
        const empresa = JSON.parse(raw);
        if (empresa != null && empresa.id != null) {
          config.headers['X-Empresa-Id'] = String(empresa.id);
        }
      }
    } catch (e) {
      /* noop */
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
  return response;
},
  function (error) {
    // O controller fiscal trata erros sem registrar payloads ou abrir HTML de validação.
    if (error.config?.nfseRequest) return Promise.reject(error);
    if (error.response) {
      const { data, status } = error.response;
      Swal.close();

      if (status === 401 && data.message === 'Unauthenticated.') {
        Swal.fire({
          icon: "warning",
          title: "Acesso negado",
          text: `Token inválido ou expurado \n Faça login novamente.`,
        });

        store.dispatch('notification/error', 'Usuário não autenticado!', { root: true });
        localStorage.removeItem('user');
        Cookie.remove('_easyindustria_token');
        location.reload(true);
      }

      if (status === 403 && data.message === 'This action is unauthorized.') {
        Swal.fire({
          icon: "warning",
          title: "Acesso negado",
          text: `Perfil não tem permissão! \n Por favor, contate o administrador.`,
        });
        store.dispatch('notification/error', 'Usuário não autorizado!', { root: true });
      }

      if (status === 422) {
        const errors = data.errors || {};
        let mesages = '';
        Object.values(errors).flat().forEach(msg => {
          // adiciona as mensagens de erro na string messagges
          mesages += `<br />${msg}`
          console.log(msg)
        });
        Swal.fire({
          icon: "warning",
          title: "Dados inválidos",
          html: `Verifique os campos obrigatórios! <br />${mesages}`,
        })
      }
    }
    return Promise.reject(error);
  }
)

export { http, API }